import React from 'react';
import { Fab, useTheme, Zoom } from '@mui/material';

import Icon from '../Icon';

interface TabFabProps {
	/** The fab label */
	label: string;
	/** The fab icon */
	icon: string;
	/** Function called when the fab is clicked */
	onClick: React.MouseEventHandler<HTMLButtonElement>;
}

function TabFab({ label, icon, onClick }: TabFabProps) {
	const theme = useTheme();

	const transitionDuration = {
		enter: theme.transitions.duration.enteringScreen,
		exit: theme.transitions.duration.leavingScreen
	};

	return (
		<Zoom in timeout={transitionDuration} style={{ transitionDelay: `${transitionDuration.exit}ms` }} unmountOnExit>
			<div className="fixed bottom-0 right-0 z-999 m-8">
				<Fab className="m-4" variant="extended" color="secondary" onClick={onClick}>
					<Icon className="mr-4" icon={icon} />
					{label}
				</Fab>
			</div>
		</Zoom>
	);
}

export default React.memo(TabFab);
